document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".wn-bundle-card");
  const variantInput = document.querySelector('input.product-variant-id[name="id"]');

  if (!cards.length || !variantInput) return;

  cards.forEach(card => {

    card.addEventListener("click", () => {

      cards.forEach(c => c.classList.remove("active"));
      card.classList.add("active");

      variantInput.value = card.dataset.variantId;

    });

  });

});